// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "vendors-node_modules_sentry_react_esm_index_js") return "vendors-node_modules_sentry_react_esm_index_jsmin.js";
	if (chunkId === "vendors-node_modules_react-ga4_dist_index_js") return "react-ga4.min.js";
	if (chunkId === "modules_lib_analytics_src_analytics_facebookPixelScript_ts") return "modules_lib_analytics_src_analytics_facebookPixelScript_tsmin.js";
	if (chunkId === "vendors-node_modules_sentry_browser_esm_index_js") return "sentry.min.js";
	// return url for filenames based on template
	return undefined;
};